import React from 'react';
import styled from '@emotion/styled';
import { PageLayout } from '../../../../shared/layout/page/PageLayout';
import { MyBookings } from '.';
import { UserPageHeader } from '../../../../shared/components';
import { splitParkingWidgetSection } from '../../../../content-sections/domain/use-cases/splitParkingWidgetSection';
import { ParkingSection } from '../../../../content-sections/ui';
import { IParkingBookingsPageData } from '../../../domain/pages/IParkingBookingsPageData';

interface IParkingBookingsPageProps extends IParkingBookingsPageData {}

export const ParkingBookingsPage = ({ page }: IParkingBookingsPageProps) => {
	const { parkingWidgetSection } = splitParkingWidgetSection(
		page.fields.sections,
	);

	return (
		<StyledPageLayout page={page}>
			<UserPageHeader page={page} />
			{parkingWidgetSection && (
				<ParkingSection section={parkingWidgetSection} />
			)}
			<MyBookings viewAll />
		</StyledPageLayout>
	);
};

const StyledPageLayout = styled(PageLayout)`
	margin-bottom: 80px;
`;
